<template>
  <div>
    <NavBar />
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <LabelRequiredField label="MENSAGEM" />
                <textarea v-model="message" rows="3" class="form-control" />
              </div>
              <div class="col-md-6">
                <LabelRequiredField label="DATA DE ATUALIZAÇÃO" />
                <input type="date" v-model="date" class="form-control" />
              </div>
              <div class="col-md-6">
                <LabelRequiredField label="STATUS" />
                <select v-model="status" class="form-control">
                  <option value="1">ATIVO</option>
                  <option value="0">INATIVO</option>
                </select>
                <small
                  ><code>ATIVO</code> (Ícone de atualização visível para as
                  casas de repouso)
                </small>
              </div>
              <div class="col-md-12">
                <ErrorsMessages :errors="errors" />
                <WarningRequiredFields />
                <v-btn
                  @click="put"
                  :disabled="loading"
                  class="v-success float-right"
                >
                  <span class="fa fa-check mr-1"></span>
                  {{ loading ? "CARREGANDO" : "SALVAR MENSAGEM" }}
                </v-btn>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <label>O QUE FOI ADICIONADO DE NOVO?</label>
                <div class="input-group">
                  <input type="text" v-model="topic" class="form-control" />
                  <div class="input-group-pprend">
                    <v-btn @click="add" class="v-success">
                      <span class="fa fa-check mr-1"></span>
                      ADICIONAR
                    </v-btn>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <b-list-group>
                  <b-list-group-item
                    class="d-flex align-items-center justify-content-between"
                    v-for="(topic, key) in list"
                    :key="key"
                  >
                    <p class="m-0">{{ topic.message }}</p>
                    <v-btn @click="del(topic)" class="v-danger" small>
                      <span class="fa fa-remove mr-1"></span>
                      REMOVER
                    </v-btn>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </div>
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import ErrorsMessages from "../templates/components/ErrorsMessages";

import LabelRequiredField from "../templates/components/LabelRequiredField";

import WarningRequiredFields from "../templates/components/WarningRequiredFields";

import api from "../services/api";

import toast from "../components/ToastNotification";

import { formatDateToUs } from "../functions/format";

export default {
  name: "SystemUpdate",
  components: {
    NavBar,
    ErrorsMessages,
    LabelRequiredField,
    WarningRequiredFields,
  },
  data() {
    return {
      message: "",
      date: "",
      status: 0,
      list: [],
      topic: "",
      loading: false,
      errors: [],
    };
  },
  created() {
    this.get();
  },
  methods: {
    formatDateToUs,
    add() {
      if (this.topic == "" || this.topic.trim() == "") {
        return;
      }
      this.list.push({ message: this.topic });
      this.topic = "";
      this.put();
    },
    del(topic) {
      this.list.splice(this.list.indexOf(topic), 1);
      this.put();
    },
    async get() {
      try {
        this.loading = true;

        const response = await api.get("/system-update");

        const { system_update } = response.data;

        if (system_update) {
          this.message = system_update.message;
          this.date = formatDateToUs(system_update.date);
          this.status = system_update.status;
          if (system_update.list) {
            this.list = JSON.parse(system_update.list);
          }
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    async put() {
      try {
        this.loading = true;

        const { date, status, list } = this;

        let params = { message: this.message, date, status, list };

        const response = await api.put("/system-update", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.errors = [];
          this.get();
          toast(message, "success");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
  },
};
</script>